import React, {FC} from 'react';
import {Link} from 'react-router-dom';
import './styles.scss';

import Sport24Logo from 'assets/svg/logo_sport24.svg';
import MatchcenterLogo from 'assets/svg/logo_matchcenter.svg';

const Menu: FC = () => (
  <>
    {/* TODO: add billboard */}
    <nav className="Menu">
      <a className="Menu__sport24" href="https://www.sport24.gr/">
        <img src={Sport24Logo} alt="SPORT 24" />
      </a>
      <Link className="Menu__matchcenter" to="/">
        <img src={MatchcenterLogo} alt="Matchcenter | SPORT 24" />
      </Link>
    </nav>
    <div className="Menu__spacer" />
  </>
);

export default React.memo(Menu);
